(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aq-cart-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aq-cart-discount')) {
    let busy = false;
    class AqCartDiscount extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.input = this.querySelector('input');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button?.hasAttribute('data-apply')) this.apply();
          if (button?.hasAttribute('data-remove-code')) this.apply(button.dataset.removeCode);
        });
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); this.apply(); }
        });
        this.readCart().then(cart => this.renderCodes(cart)).catch(() => {});
      }
      async readCart() {
        const response = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        return response.json();
      }
      async updateCart(codes) {
        const response = await fetch(this.dataset.cartUrl + '/update.js', {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({discount:codes.join(',')})
        });
        if (!response.ok) throw new Error('discount');
        return response.json();
      }
      renderCodes(cart) {
        const container = this.querySelector('.aq-cart-discount__codes');
        container.replaceChildren();
        for (const code of cart.discount_codes || []) {
          if (!code.applicable) continue;
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.removeCode = code.code;
          button.textContent = code.code + ' ×';
          button.setAttribute('aria-label', this.dataset.remove + ' ' + code.code);
          container.append(button);
        }
      }
      say(message, error = false) {
        const status = this.querySelector('.aq-cart-discount__status');
        status.textContent = message;
        status.hidden = !message;
        status.classList.toggle('is-error', error);
      }
      async apply(removeCode) {
        if (busy) return;
        const code = (removeCode || this.input.value).trim();
        if (!code) { this.input.focus(); return; }
        busy = true;
        document.querySelectorAll('aq-cart-discount button').forEach(button => button.disabled = true);
        this.say('');
        try {
          const before = await this.readCart();
          const previous = (before.discount_codes || []).filter(item => item.applicable).map(item => item.code);
          const codes = previous.filter(item => item.toLowerCase() !== code.toLowerCase());
          if (!removeCode) codes.push(code);
          let result = await this.updateCart(codes);
          const applied = (result.discount_codes || []).some(item => item.applicable && item.code.toLowerCase() === code.toLowerCase());
          if (!removeCode && !applied) {
            result = await this.updateCart(previous);
            this.say(this.dataset.invalid, true);
          } else {
            this.input.value = '';
            this.say(removeCode ? '' : this.dataset.success);
          }
          document.querySelectorAll('aq-cart-discount').forEach(component => component.renderCodes(result));
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        } catch (error) {
          this.say(this.dataset.error, true);
        } finally {
          busy = false;
          document.querySelectorAll('aq-cart-discount button').forEach(button => button.disabled = false);
        }
      }
    }
    customElements.define('aq-cart-discount', AqCartDiscount);
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-aqc-remove-code]');
      if (!button) return;
      const component = document.querySelector('.aqc aq-cart-discount');
      if (component) component.apply(button.dataset.aqcRemoveCode);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
